import SectionHeader from "../../include/SectionHeader";

const WhyLifeline = () => {
    return (
        <>
        <div className="progress-section aboutus_why_section py-5">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <SectionHeader title={"Why Lifeline Tulasi Hospital ?"} />
                        <p className="theme-para mt-3">We provide the most dedicated expert service with world class infrastucture and facilities that makes our patients live a better, healthier, and a happier life. Our high quality medical services comes to you at an affordbale cost along with holistic and empathetic care. Our 25+ years of experience has enabled clinical precision, timely treatment and complete cure for all your medical needs.</p>
                    </div>
                    <div className="col-12">
                        <div className="trust-section">
                            <div className="mb-5 mt-3">
                                <SectionHeader subtitle={"Our core competencies include:"} />
                            </div>
                            <div className="trust-main-section mb-5">
                                <div className="single-trust">
                                    <p className="trust-letter">T</p>
                                    <img src="/assets/img/trust-t-f.png" alt="trust-t" className="img-fluid trust-icon" />
                                    <p className="trust-desc">Timely care</p>
                                </div>
                                <div className="single-trust">
                                    <p className="trust-letter">R</p>
                                    <img src="/assets/img/trust-r.png" alt="trust-r" className="img-fluid trust-icon" />
                                    <p className="trust-desc">Ready team of experts for your medical worries</p>
                                </div>
                                <div className="single-trust">
                                    <p className="trust-letter">U</p>
                                    <img src="/assets/img/trust-u.png" alt="trust-u" className="img-fluid trust-icon" />
                                    <p className="trust-desc">Unmatched State-of-the-art infrastructure and facilities</p>
                                </div>
                                <div className="single-trust">
                                    <p className="trust-letter">S</p>
                                    <img src="/assets/img/trust-s.png" alt="trust-s" className="img-fluid trust-icon" />
                                    <p className="trust-desc">Service Excellence</p>
                                </div>
                                <div className="single-trust">
                                    <p className="trust-letter">T</p>
                                    <img src="/assets/img/trust-t.png" alt="trust-t" className="img-fluid trust-icon" />
                                    <p className="trust-desc">Truthful, Compassionate, and empathetic care</p>
                                </div>
                            </div>
                            <SectionHeader subtitle={"We are a one-of-a-kind, tertiary care medical facility in Hydrabad, providing premium service at affordable costs."} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default WhyLifeline;